import { fetchLanguageCodes } from "../helpers/languageHelper";
import { LANGUAGE_CODES } from "../constants/language-constants";

let localeMap = {};

const buildLocaleMap = async () => {
  const locales = await fetchLanguageCodes();
  locales.forEach((locale) => {
    const lowerFull = locale.toLowerCase(); 
    const parts = lowerFull.split('-'); 
    if (parts.length >= 2) {
      const country = parts[parts.length - 1];
      localeMap[lowerFull] = country.toUpperCase();
      localeMap[country] = country.toUpperCase();
    } else {
      localeMap[lowerFull] = lowerFull.toUpperCase();
    }
  });
};

buildLocaleMap();

export const getFlagCode = (alias) => {
  if (!alias) return null;
  const lowerAlias = alias.trim().toLowerCase();
  return localeMap[lowerAlias] || null;
};


const fetchCountries = async () => {
  try {
    const response = await fetch('/data/countries.json');
    if (!response.ok) {
      return [];
    }
    const countries = await response.json();
    return countries;
  } catch (error) {
    return [];
  }
};

export const getCountry = async () => {
  const map = [];
  await fetchCountries().then(countries => {
    for (const country of countries) {
      map.push({ name: country.name.common, code: country.cca2 });
    };
  });
  return map.sort((a, b) => {
      if (a.code === LANGUAGE_CODES.KOREAN) return -1;
      if (b.code === LANGUAGE_CODES.KOREAN) return 1;
      if (a.code === LANGUAGE_CODES.VIETNAMESE) return -1;
      if (b.code === LANGUAGE_CODES.VIETNAMESE) return 1;
      if (a.code === LANGUAGE_CODES.ENGLISH) return -1;
      if (b.code === LANGUAGE_CODES.ENGLISH) return 1;
      return a.name.localeCompare(b.name);
    });
}
